module.exports = __webpack_public_path__ + "img/ABISL.53f8d3c2.jpg";